// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/chunk-" + {"346":"65517bd918784343","898":"8a7c0161ccd2407b"}[chunkId] + ".js";
};